<template>
  {{ companyName }}
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { companiesService } from '@/services/companiesService'

const companyName = ref('')

onMounted(async () => {
  try {
    companyName.value = await companiesService.resolveDefaultCompanyName()
  } catch {
    companyName.value = ''
  }
})
</script>
